import messagesEmptyState from "../../../../src/pages/foundations/content/designing-messages/_assets/messages-empty-state.png";
import messagesBanner from "../../../../src/pages/foundations/content/designing-messages/_assets/messages-banner.png";
import messagesFlag from "../../../../src/pages/foundations/content/designing-messages/_assets/messages-flag.jpg";
import messagesSectionMessages from "../../../../src/pages/foundations/content/designing-messages/_assets/messages-section-messages.png";
import messagesInlineDialog from "../../../../src/pages/foundations/content/designing-messages/_assets/messages-inline-dialog.jpg";
import messagesModal from "../../../../src/pages/foundations/content/designing-messages/_assets/messages-modal.jpg";
import spotlightSingleStep from "../../../../src/pages/foundations/content/designing-messages/_assets/single-step.png";
import colorRolesAndIcons from "../../../../src/pages/foundations/content/designing-messages/_assets/color-roles-and-icons.png";
import * as React from 'react';
export default {
  messagesEmptyState,
  messagesBanner,
  messagesFlag,
  messagesSectionMessages,
  messagesInlineDialog,
  messagesModal,
  spotlightSingleStep,
  colorRolesAndIcons,
  React
};